import React from "react";
import { GridColumn, GridContainer, GridRow } from "arv-reactcomponents";
import { OrderConfirmation } from "npmlinks-constants";
import PropTypes from "prop-types";
import { ToCurrency } from "../../../utils";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const PricingDetailsBlock = props => {
  const { pricingDetails } = props;
  return (
    <GridContainer className="nw-orderconfirm-pricingdetails-container">
      <GridRow>
        <GridColumn className="nwc-grid-col-sm-12 nw-orderconfirm-pricingdetails-title">
          {ORDERCONFIRMPAGE.PRICING_DETAILS_BLOCK.TITLE}
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-pricingdetails-row">
        <GridColumn className="nwc-grid-col-xs-6">
          {ORDERCONFIRMPAGE.PRICING_DETAILS_BLOCK.SUBTOTAL}
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6 nw-orderconfirm-pricingdetails-value-col">
          {ToCurrency(pricingDetails.subTotal)}
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-pricingdetails-row">
        <GridColumn className="nwc-grid-col-xs-6">
          {ORDERCONFIRMPAGE.PRICING_DETAILS_BLOCK.SHIPPING}
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6 nw-orderconfirm-pricingdetails-value-col">
          {ToCurrency(pricingDetails.shipping)}
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-pricingdetails-row">
        <GridColumn className="nwc-grid-col-xs-6">
          {ORDERCONFIRMPAGE.PRICING_DETAILS_BLOCK.TAX}
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6 nw-orderconfirm-pricingdetailstax">
          {ToCurrency(pricingDetails.tax)}
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-pricingdetails-row">
        <GridColumn className="nwc-grid-col-xs-6">
          {ORDERCONFIRMPAGE.PRICING_DETAILS_BLOCK.DISCOUNTS}
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6 nw-orderconfirm-pricingdetails-discountvalue">
          - {ToCurrency(pricingDetails.discounts)}
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-pricingdetails-row-total ">
        <GridColumn className="nwc-grid-col-xs-6">
          {ORDERCONFIRMPAGE.PRICING_DETAILS_BLOCK.TOTAL}
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6 nw-orderconfirm-pricingdetails-value-col">
          {ToCurrency(pricingDetails.total)}
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

PricingDetailsBlock.propTypes = {
  pricingDetails: PropTypes.object.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: PricingDetailsBlock,
  component: PricingDetailsBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/PricingDetailsBlock/index.js